<div
  class="relative flex h-full flex-col gap-8 rounded p-8 outline transition-all"
  [ngClass]="{
    'outline-2 outline-primary-border': seats() > 0,
    'outline-[1.5px] outline-border-secondary': seats() <= 0,
    'lg:flex-row lg:items-end lg:ps-12': row(),
  }"
>
  <div
    class="absolute top-4 right-4 size-4 rounded-full transition-all"
    [ngClass]="{
      'bg-primary-border': seats() > 0,
      'bg-transparent': seats() <= 0,
      'lg:top-1/2 lg:top-8 lg:right-8 lg:right-auto lg:left-4 lg:-translate-y-1/2':
        row(),
    }"
  ></div>

  <div
    class="flex items-start gap-8"
    [ngClass]="{ 'flex-col 2xl:flex-row': row() }"
  >
    @if (product().magazine.length > 0) {
      <div class="flex flex-shrink-0 items-end gap-1">
        @for (
          magazine of product().magazine
            | filterBy: ['archived'] : [false]
            | slice: 0 : 2;
          track magazine.title
        ) {
          <img
            class="mb-1.5 -ml-6 h-24 w-18 shadow-medium first:z-10 first:mb-0 first:ml-0 first:h-48 first:w-36"
            [ngSrc]="
              magazine.media.cover?.url ?? 'assets/images/image-placeholder.png'
            "
            [alt]="magazine.title"
            [title]="magazine.title"
            height="128"
            width="96"
          />
        }
      </div>
    }

    <div class="flex flex-col gap-4">
      <h4 class="text-2xl font-medium" [ngClass]="{ 'flex-grow': !row() }">
        {{ product().name }}
      </h4>
      <div
        class="description"
        [innerHTML]="sanitize(product().description)"
      ></div>
    </div>
  </div>
  <div class="flex flex-grow flex-col gap-2">
    <div class="flex items-baseline gap-4">
      <div class="flex flex-col gap-1 text-sm font-medium">
        <div
          class="flex items-baseline gap-2"
          [ngClass]="{
            'lg:flex-col': row(),
          }"
        >
          <span class="text-lg">
            {{ getPrice() | currency: 'EUR' }}
          </span>
          <span class="text-text-secondary">
            {{
              'components.productCard.perUser'
                | translate: { amount: [seats(), 1] | max }
            }}
          </span>
        </div>
        <span class="text-text-secondary">
          {{ 'components.productCard.pricePerYear' | translate }}
        </span>
      </div>
    </div>
  </div>
  <div class="ms-auto flex flex-col items-end justify-between gap-3">
    @if (row()) {
      <div class="mt-auto">
        <input
          class="input"
          [(ngModel)]="customerCostReference"
          [placeholder]="
            'components.productCard.customerCostReference' | translate
          "
          (ngModelChange)="onCustomerCostReferenceChange($event)"
          autocorrect="off"
          autocomplete="off"
        />
      </div>
    }
    <div class="flex items-center gap-2.5">
      @if (!row()) {
        <span class="" [ngClass]="{ 'whitespace-nowrap': row() }">
          {{ 'components.productCard.amountOfUsers' | translate }}
        </span>
      }
      <dhp-numerical-input
        [minSelected]="minSelected()"
        [ngModel]="seats()"
        (ngModelChange)="onChange($event)"
      ></dhp-numerical-input>
    </div>
  </div>
</div>
